export default "__VITE_ASSET__CCfFi7xL__"